var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDownloadLegalApplication(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/download"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M7.49935 9.16602V14.166M7.49935 14.166L9.16602 12.4993M7.49935 14.166L5.83268 12.4993M18.3327 8.33268V12.4993C18.3327 16.666 16.666 18.3327 12.4993 18.3327H7.49935C3.33268 18.3327 1.66602 16.666 1.66602 12.4993V7.49935C1.66602 3.33268 3.33268 1.66602 7.49935 1.66602H11.666M18.3327 8.33268H14.9993C12.4993 8.33268 11.666 7.49935 11.666 4.99935V1.66602M18.3327 8.33268L11.666 1.66602",
    stroke: "#5E4005",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadLegalApplication);
export default __webpack_public_path__ + "static/media/download_legal_application.cf64ff7dab7b5dbcb8a005a4782c575c.svg";
export { ForwardRef as ReactComponent };